import styled from 'styled-components';
import colors from 'constants/colors';

export const RevenueReportSubHeader = styled.div`
  width: 100%;
  height: 50px;
  justify-content: flex-start;

  .dropDownContainer {
    display: flex;
    align-items: center;
    width: 295px;
    margin-left: 20px;
    margin-right: 35px;
    
    .title {
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 1px;
      color: ${colors.silver};
      margin-right: 5px;
    }
    
    .select {
      height: 40px;
      width: 239px;
      background-position: 95% 50%;
      background-size: 11px 11px;
    }
  }
`;

export const RevenueReportTableContainer = styled.table`
  width: 100%;
  color: ${colors.white};
  font-size: 14px;

  th {
    border-top: 1px solid ${colors.charcoal};
    border-bottom: 1px solid ${colors.white};
    border-left: 1px solid ${colors.white};
    padding: 5px 10px;
    height: 42px;
  }

  td {
    border-left: 1px solid ${colors.white};
    border-bottom: 1px solid ${colors.charcoal};
    padding: 5px 20px;
    height: 44px;
    :first-child {
      border-left: none;
    }
  }

  tbody {
    tr:nth-child(odd) {
      background-color: ${colors.black1}
    }
    tr:nth-child(even) {
      background-color: ${colors.black5}
    }
  }

  .titleCell {
    width: 14%;
    border-left: none;
  }

  .compareCell {
    width: 15%;
    padding-left: 20px;
  }

  .title {
    color: ${colors.silver};
    text-align: right;
  }

  .titleHighlight {
    font-weight: bold;
    text-align: right;
  }
`;
